import Glide from '@glidejs/glide';

import React, { Component, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

/**
 * React Glide Slider
 * Glide Carousel used to display client testimonials with an optional case study to the left
 * @param props { displayCaseStudy: boolean, slides: {author, authorTitle, company, companyLogoUrl, quote, reviewStarRating, reviewLinkUrl, reviewLinkTitle, reviewVideoThumbnail, reviewVideoEmbed }[] }
 */
export class ReactGlide extends Component {

    constructor() {
        super();
        this.id = 'react-glide-' + Math.round(Math.random() * 10e6);
        
    }

    noop() {}
    
    componentDidMount() {
        this.slider = new Glide('#' + this.id, {
            autoplay: 7000,
            hoverpause: true
        });
        
        // Automated height on Carousel change
        this.slider.on('mount.after', (e) => this.updateTrackHeight(e));
        this.slider.on('run', (e) => this.updateTrackHeight(e));
        // this.slider.resize();
        this.slider.on('build.after', (e) => this.updateTrackHeight(e));
        window.onload = function () {
            let width = window.outerWidth;
            let height = window.outerHeight;
            window.resizeTo(width - 10, height - 10);
            window.resizeTo(width, height);
        }

        // Only mount if we need the slider
        setTimeout(() => this.props.slides.length > 1 ? this.slider.mount() : this.noop());
    }

    updateTrackHeight(event) {
        const nextSlideIndex = this.slider.index !== undefined ? this.slider.index : (event.direction === '>' ? this.props.slides.length : 0);
        const nextSlide = document.getElementById(`${this.id}-slides`).children.item(nextSlideIndex);
        const glideTrack = document.getElementById(`${this.id}-track`);
        if (nextSlide) {
            glideTrack.style.height = `${nextSlide.offsetHeight}px`;
        }
    }

    slideCaseStudy(slide) {
        return (
            <div className='glide__slide__case__study card'>
                <div className="card-body">
                    <div className='case__study__logo__wrapper'>
                        <img src={slide.companyLogoUrl} alt={slide.companyName + ' logo'}/>
                    </div>
                    <div className='case__study__content__wrapper'>
                        <h3 className="case__study__heading">{slide.caseStudy.heading}</h3>
                        <p className='case__study__content' dangerouslySetInnerHTML={{ __html: slide.caseStudy.content }}/>
                    </div>
                    <div className='case__study__link__wrapper'>
                        <a href={slide.caseStudy.link.url} className='case__study__link' target="blank">
                            <span className="hoverable">{slide.caseStudy.link.title}</span>
                        </a>
                    </div>
                </div>
            </div>
        );
    }

    slideCaseStudyMobile(slide) {
        return (this.props.displayCaseStudy && slide.caseStudy && slide.caseStudy.link) ? (
            <div className="glide__slide__case__study__mobile mt-5">
                <a href={slide.caseStudy.link.url} className='btn btn-primary case__study__link' target="blank">
                    <span className="hoverable">{slide.caseStudy.link.title}</span>
                </a>
            </div>
        ) : '';
    }

    slideContent(slide) {
        slide.modal_id = 'modal-' + Math.round(Math.random() * 10e6);
        return (this.props.displayVideoTestimonial && slide.reviewVideoThumbnail && slide.reviewVideoEmbed) ? (
            <div className='glide__slide__content video-variant'>
                <div className='slide__video__content__wrapper'>
                    <div className='slide__logo__wrapper'>
                        <img src={slide.companyLogoUrl} alt={slide.companyName + ' logo'}/>
                    </div>
                    <div className='slide__content__wrapper'>
                        <p className='slide__content'>{slide.quote}</p>

                    </div>

                </div>
                <div className='slide__video__wrapper'>
                    {this.slideTestimonialVideo(slide)}
                </div>
                <div className='slide__content__wrapper'>
                    <p className='slide__author'>{[slide.author, slide.authorTitle, slide.company].join(', ')}</p>
                    </div>
                <div className='slide__reviews__wrapper'>
                        {this.reviewStars(slide)}
                        <a href={slide.reviewLinkUrl} target="blank">{slide.reviewLinkTitle || 'See our reviews on G2'}</a>
                    </div>
                {this.slideCaseStudyMobile(slide)}
            </div>
        ) : (
            <div className='glide__slide__content'>
                <div className='slide__logo__wrapper'>
                    <img src={slide.companyLogoUrl} alt={slide.companyName + ' logo'}/>
                </div>
                <div className='slide__content__wrapper'>
                    <p className='slide__content'>{slide.quote}</p>
                    <p className='slide__author'>{[slide.author, slide.authorTitle, slide.company].join(', ')}</p>
                </div>
                <div className='slide__reviews__wrapper'>
                    {this.reviewStars(slide)}
                    <a href={slide.reviewLinkUrl} target="blank">{slide.reviewLinkTitle || 'See our reviews on G2'}</a>
                </div>
                {this.slideCaseStudyMobile(slide)}
            </div>
        );
    }

    slideTestimonialVideoModal(slide) {
        return (slide.reviewVideoThumbnail && slide.reviewVideoEmbed) ? (
            <div className="modal fade" id={slide.modal_id} key={slide.author} tabIndex="-1" aria-labelledby={slide.modal_id} aria-hidden="true">
                <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-body p-0">
                            <div className="embed-responsive embed-responsive-16by9">
                                <iframe id={slide.modal_id + "-iframe"}
                                    className="embed-responsive-item"
                                    data-src={slide.reviewVideoEmbed.toString()} 
                                    frameBorder="0" 
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                    allowFullScreen>
                                </iframe>
                            </div>
                        </div>
                    </div>
                </div>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span className="sr-only" aria-hidden="true">Close Modal</span>
                </button>
            </div>
        ) : (
            null
        );
    }
    
    updateIframeSrc(slide) {
        const modal = document.getElementById(slide.modal_id);
        if (modal) {
            const iframe = modal.querySelector('iframe[data-src]');
            if (iframe) {
                iframe.setAttribute('src', iframe.dataset.src);
                iframe.dataset.src = null;
            }
        }
    }

    slideTestimonialVideo(slide) {
        return (
            <div className='glide__slide__testimonial__video'>
                <div className='video_content_wrapper'>
                    <button onClick={() => this.updateIframeSrc(slide)} data-toggle="modal" data-target={"#" + slide.modal_id} className="btn btn-link testimonial-video-link content-block-link--launch-video">
                        <i className="icon"><svg viewBox="0 0 16 16" preserveAspectRatio="xMidYMid meet"><use href="#icon-play-circle"></use></svg></i>
                        <span className="hoverable">Watch the Testimonial</span>
                    </button>
                    <img src={slide.reviewVideoThumbnail} alt="" />
                </div>
            </div>
        );
    }


    
    slide(slide, index) {
        return (this.props.displayCaseStudy && slide.caseStudy && (slide.caseStudy.heading || slide.caseStudy.content)) ? (
            <li id={`${this.id}-slide-${index}`} className="glide__slide glide__slide--case__study" key={slide.author}>
                {this.slideCaseStudy(slide)}
                {this.slideContent(slide)}
            </li>
        ) : (
            <li className='glide__slide' key={slide.author}>
                {this.slideContent(slide)}
            </li>
        );
    }
    
    reviewStars(slide) {
        const stars = Array(5).fill(null);
        const starCount = +slide.reviewStarRating;
        return (
            <div className='slide__review__stars'>
                {stars.map((s, i) => (
                    <span className={'slide__review__star ' + (i < starCount ? 'filled' : 'empty')} key={i}>
                        <svg width="18px" height="17px" viewBox="0 0 18 17" preserveAspectRatio='xMidYMid meet'>
                            <use href='#icon-star'></use>
                        </svg>
                    </span>
                ))}
                <span className="sr-only">This reviewer gave a {starCount} star rating</span>
            </div>
        );
    }
    
    bullets(slides) {
        return (
            <div className="glide__bullets" data-glide-el="controls[nav]">
                {slides.map((slide, i) => (
                    <button className="glide__bullet" key={i} data-glide-dir={'=' + i}>
                        <span className="sr-only">Go to slide {i+1}</span>
                    </button>
                ))}
            </div>
        );
    }

    arrows() {
        return (
            <div className="glide__arrows" data-glide-el="controls">
                <button className="glide__arrow glide__arrow--right" data-glide-dir=">">
                    <i className="chevron"></i>
                    <span className="sr-only">Next slide</span>
                </button>
                <button className="glide__arrow glide__arrow--right" data-glide-dir="<">
                    <i className="chevron-left"></i>
                    <span className="sr-only">Previous slide</span>
                </button>
            </div>
        );
    }
    
    render() {
        return (this.props.displayVideoTestimonial) ? (
            <div className="react-glide-wrapper">
                <div className='react-glide glide video-glide' id={this.id}>
                    <div className='glide__track' data-glide-el='track' id={`${this.id}-track`}>
                        <ul className='glide__slides' id={`${this.id}-slides`}>
                            {this.props.slides.map((slide, index) => this.slide(slide, index))}
                        </ul>
                    </div>
                    {this.props.slides.length > 1 && this.bullets(this.props.slides)}
                    {this.props.slides.length > 1 && this.arrows()}
                </div>
                <div className="modals">
                    {this.props.slides.map((slide, index) => this.slideTestimonialVideoModal(slide, index))}
                </div>
            </div>
			
        ) : (
            <div className='react-glide glide' id={this.id}>
                <div className='glide__track' data-glide-el='track' id={`${this.id}-track`}>
                    <ul className='glide__slides' id={`${this.id}-slides`}>
                        {this.props.slides.map((slide, index) => this.slide(slide, index))}
                    </ul>
                </div>
                {this.props.slides.length > 1 && this.bullets(this.props.slides)}
                {this.props.slides.length > 1 && this.arrows()}
            </div>
		);
    }
    
}

const reactGlideElements = Array.from(
	document.querySelectorAll('[data-react-component="ReactGlide"]')
);
if (reactGlideElements.length) {
	reactGlideElements.forEach(el => {
		if (el.dataset.reactProps) {
            const props = JSON.parse(el.dataset.reactProps);
            //console.log(props);
			ReactDOM.render(<ReactGlide slides={props.slides} displayCaseStudy={props.displayCaseStudy} displayVideoTestimonial={props.displayVideoTestimonial} />, el);
		} else {
			console.log('Missing required props');
		}
	});
}
